import Field from './Field';
import { DIAGNOSIS_OPTIONS } from '../../constants/adrData';

export default function MedicalInfoSection({ form, errors, selectedDrugRegimens, selectedSideEffects, onChange }) {
  return (
    <>
      <div className="form-section-label">💊 Medical Information</div>
      <div className="grid-2">
        <Field
          label="Diagnosis / Condition (નિદાન / સ્થિતિ)"
          name="diagnosis"
          as="select"
          options={DIAGNOSIS_OPTIONS}
          required
          value={form.diagnosis}
          error={errors.diagnosis}
          onChange={onChange}
        />

        <Field
          label="Date of Reaction (આડ અસર ની તારીખ)"
          name="reactionDate"
          type="date"
          value={form.reactionDate}
          error={errors.reactionDate}
          onChange={onChange}
        />
      </div>

      {selectedDrugRegimens.length > 0 && (
        <Field
          label="Chemotherapy Drugs(કીમોથેરાપીની દવાઓ)"
          name="drugRegimen"
          as="select"
          options={selectedDrugRegimens}
          value={form.drugRegimen}
          error={errors.drugRegimen}
          onChange={onChange}
        />
      )}

      {selectedSideEffects.length > 0 && (
        <Field
          label="Known Side Effects"
          name="sideEffects"
          as="checkboxes"
          options={selectedSideEffects}
          value={form.sideEffects}
          error={errors.sideEffects}
          onChange={onChange}
        />
      )}
    </>
  );
}
